import script from "./GitHistoryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GitHistoryPage.vue?vue&type=script&setup=true&lang=ts"

import "./GitHistoryPage.vue?vue&type=style&index=0&id=556b750e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-556b750e"]])

export default __exports__